import React, { useState, useEffect } from "react";
import { priceData } from "../../data/priceData";

const ProductPrice = ({
  activeStepOne,
  handleAddToCart,
  errorQuantity,
  setErrorQuantity,
  pricePerItem,
  selectedKitPrice,
  kitOptions,
}) => {
  const [quantity, setQuantity] = useState(null);
  // const [pricePerItem, setPricePerItem] = useState(0.99);

  // Get the active price tier based on the activeStepOne label
  // const activePriceTier = priceData.find((tier) => tier.label === "tier1");

  // Calculate the price based on quantity and active tier
  // const calculatePrice = (qty) => {
  //   if (!activePriceTier) return 0; // Default to 0 if no tier is active
  //   const discount = activePriceTier.priceDiscount.find(
  //     (discount) => qty >= discount.startQuantity && qty <= discount.endQuantity
  //   );
  //   return discount ? discount.price : 0; // Default to 0 if no match
  // };

  // useEffect(() => {
  //   const newPrice = calculatePrice(quantity);
  //   setPricePerItem(newPrice);
  // }, [quantity, activePriceTier]);

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value) || null;
    setQuantity(value);
    setErrorQuantity(null);
  };

  const totalPrice = (quantity * pricePerItem).toFixed(2);

  return (
    <div className="p-6 max-w-4xl m-4 border border-purple-300 shadow-lg bg-gradient-to-br from-purple-600 to-blue-600 text-white rounded-lg">
      <div className="space-y-4 bg-white/10 backdrop-blur-sm p-4 rounded-lg">
        {/* Quantity Input */}
        <div>
          <label htmlFor="quantity" className="block text-xl mb-2">
            Quantity
          </label>
          <input
            type="number"
            id="quantity"
            min="1"
            value={quantity}
            onChange={handleQuantityChange}
            className="w-full p-3 text-gray-800 rounded-lg border-2 text-md border-purple-200 focus:border-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-300 transition-all duration-300"
          />

          {errorQuantity && (
            <p className="text-red-500 text-sm mt-1">
              Please enter a valid quantity
            </p>
          )}
        </div>

        {/* Total Price */}
        <div className="flex items-center justify-between bg-white/20 p-3 rounded-lg">
          {/* <div className="text-2xl font-bold">${totalPrice}</div> */}
          <button
            className="px-6 py-2 border-2 border-white text-white rounded-lg hover:bg-white hover:text-purple-600 transition-all duration-300 font-semibold transform hover:scale-105"
            onClick={(e) =>
              handleAddToCart(e, totalPrice, quantity, selectedKitPrice)
            }
          >
            PLACE ORDER
          </button>
        </div>

        {/* Discounts Table */}
        {/* <div className="bg-white/20 p-3 rounded-lg"> */}
        {/* <h3 className="text-xl mb-2">
            Quantity Discounts - Prices Reduce in Cart
          </h3> */}
        {/* <div className="space-y-1">
            {activePriceTier?.priceDiscount.map((tier, index) => (
              <div
                key={index}
                className="flex justify-between border-b border-purple-400 py-2  transition-colors duration-200"
              >
                <span>
                  {tier.endQuantity === Infinity && activeStepOne !== "luna"
                    ? `${tier.startQuantity}+`
                    : activeStepOne !== "luna" &&
                      `${tier.startQuantity}-${tier.endQuantity}`}
                </span>
                <span>${tier.price.toFixed(2)}</span>
              </div>
            ))}
          </div> */}
        {/* </div> */}

        {/* Additional Info */}
        {/* <p className="text-sm italic mt-4 bg-white/20 p-2 rounded-lg">
          *Fees for additional extras will be applied at cart level
        </p> */}
      </div>
    </div>
  );
};

export default ProductPrice;
